import React from "react";
import { XCircleIcon } from "@heroicons/react/24/outline";
import { TWclassNames } from "../Div";

export function TagsView({ tags, onDeleteTag = null }) {
  const tagColor = (tag) => {
    switch (tag?.module) {
      case "hse_quality":
        return "bg-purple-100 text-purple-800";
      case "hse_instruction":
        return "bg-indigo-100 text-indigo-800";
      case "report":
        return "bg-blue-100 text-blue-800";
      case "contact":
        return "bg-green-100 text-green-800";
      case "customer":
        return "bg-red-100 text-black";
      case "project":
        return "bg-yellow-100 text-yellow-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  const TagTitle = (tag) => {
    if (tag?.object?.title) {
      return tag.object.title;
    }
    if (tag?.object?.displayTitle) {
      return tag.object.displayTitle;
    }
    if (tag?.id && tag?.object) {
      return tag.object.title || tag.object.displayTitle || `${tag.module} ${tag.module_param}`;
    }
    return `${tag.module} ${tag.module_param || ""}`;
  };

  if (!tags || tags.length === 0) {
    return null;
  }

  return tags.map((item, idx) => {
    return (
      <span
        key={item?.id || item?.module + item?.module_param || idx}
        className={TWclassNames(
          tagColor(item),
          "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium mr-2"
        )}
      >
        <span className="flex justify-between">
          <span>{TagTitle(item)}</span>
          {onDeleteTag && (
            <button
              type="button"
              className="cursor-pointer ml-2"
              onClick={onDeleteTag(idx)}
            >
              <XCircleIcon className="h-4 w-4" />
            </button>
          )}
        </span>
      </span>
    );
  });
}

